import classNames from 'classnames/bind';
import React, { Component } from 'react';

import styles from './ErrorBoundary.module.scss';

import ContainerFullHeight from '@/components/ui/ContainerFullHeight';

const cx = classNames.bind(styles);

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this.setVh = this.setVh.bind(this);
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error(error);
  }

  componentDidMount() {
    this.setVh();
    window.addEventListener('resize', this.setVh);
    window.addEventListener('orientationchange', this.setVh);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.setVh);
    window.removeEventListener('orientationchange', this.setVh);
  }

  setVh() {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
  }

  reload() {
    window.location.replace('/');
  }

  render() {
    if (this.state.hasError) {
      return (
        <ContainerFullHeight className={cx('container')}>
          <div className={cx('form')}>
            <div className={cx('message')}>
              An unexpected error occurred.
              <br />
              <span className={cx('accent')}>Please reload the page again.</span>
              <br />
              If the problem persists, please contact the administrator.
            </div>
            <button type="button" className={cx(['button', 'accent'])} onClick={this.reload}>
              Reload
            </button>
          </div>
        </ContainerFullHeight>
      );
    }

    return this.props.children;
  }
}
